/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiTenantSessionDto } from './MultiTenantSessionDto';
import {
    MultiTenantSessionDtoFromJSON,
    MultiTenantSessionDtoFromJSONTyped,
    MultiTenantSessionDtoToJSON,
    MultiTenantSessionDtoToJSONTyped,
} from './MultiTenantSessionDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface SessionListResponse
 */
export interface SessionListResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SessionListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SessionListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SessionListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<MultiTenantSessionDto>}
     * @memberof SessionListResponse
     */
    data?: Array<MultiTenantSessionDto>;
    /**
     * 
     * @type {number}
     * @memberof SessionListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SessionListResponse interface.
 */
export function instanceOfSessionListResponse(value: object): value is SessionListResponse {
    return true;
}

export function SessionListResponseFromJSON(json: any): SessionListResponse {
    return SessionListResponseFromJSONTyped(json, false);
}

export function SessionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(MultiTenantSessionDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SessionListResponseToJSON(json: any): SessionListResponse {
    return SessionListResponseToJSONTyped(json, false);
}

export function SessionListResponseToJSONTyped(value?: SessionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(MultiTenantSessionDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

